"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgAmenityOneTap(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({}, props, {
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    className: "Icon ".concat(props.className ? props.className : ''),
    ref: svgRef
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.2 147.2C860.8 64 790.4 0 707.2 0H316.8c-83.2 0-153.6 64-160 147.2V864c0 89.6 70.4 160 160 160h390.4c89.6 0 160-70.4 160-160V153.6v-6.4zm-70.4 720c-3.2 48-44.8 86.4-96 86.4H320c-48 0-89.6-38.4-96-86.4h572.8zm-560-745.6c16-32 48-51.2 83.2-51.2h384c35.2 0 67.2 19.2 83.2 51.2H236.8zm560 70.4v608H227.2V192h569.6z"
  }));
}

var ForwardRef = React.forwardRef(SvgAmenityOneTap);
var _default = ForwardRef;
exports.default = _default;